// src/components/SchemesList.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./SchemesList.css";

const SchemesList = ({ schemes }) => {
  if (!schemes || schemes.length === 0) return null;

  // FILTER → Only schemes marked for SchemesList
  const filteredSchemes = schemes.filter(
    (scheme) => scheme.showInSchemeList === true
  );

  return (
    <>
      {filteredSchemes.map((scheme) => {
        // Filter categories to only visible ones
        const visibleCategories = (scheme.categories || []).filter(
          (cat) => cat.showInSchemeList === true
        );

        if (visibleCategories.length === 0) return null; // skip empty schemes

        return (
          <div key={scheme._id} className="col-lg-4 col-md-6 col-sm-12">
            <div
              className="scheme-card card h-100 shadow-sm"
              onClick={() =>
                (window.location.href = `/main/${encodeURIComponent(
                  scheme.mainCategory
                )}`)
              }
              style={{ cursor: "pointer" }}
            >
              <div className="card-body">
                
                {/* MAIN CATEGORY TITLE */}
                <h5 className="scheme-card-title mb-3">
                  <Link
                    to={`/main/${scheme.mainCategory}`}
                    onClick={(e) => e.stopPropagation()}
                    className="scheme-card-title"
                  >
                    {scheme.mainCategory}
                  </Link>
                </h5>

                {/* CATEGORY LIST */}
                <div className="scheme-scroll">
                  {visibleCategories.map((cat, i) => {
                    // filter visible subcategories
                    const visibleSubs = (cat.subcategories || []).filter(
                      (sub) => sub.showInSchemeList === true
                    );

                    if (visibleSubs.length === 0) return null;

                    return (
                      <p key={i} className="scheme-item">
                        <i className="bi bi-caret-right-fill"></i>

                        <Link
                          to={`/category/${cat.name}`}
                          className="scheme-link-blue"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {cat.name}
                        </Link>
                      </p>
                    );
                  })}
                </div>

              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default SchemesList;
